export const categories = [
  {
    slug: "neirong-chuangzuo",
    name: "内容创作",
    description: "优质内容策划与制作，涵盖图文、短视频、直播等多种形式，助力创作者高效产出爆款内容。",
    icon: "ri-quill-pen-line",
    articleCount: 48,
  },
  {
    slug: "guanggao-toufang",
    name: "广告投放",
    description: "精准广告投放策略，覆盖主流社交媒体与信息流平台，实现品牌曝光与转化双增长。",
    icon: "ri-advertisement-line",
    articleCount: 36,
  },
  {
    slug: "pinpai-tuiguang",
    name: "品牌推广",
    description: "全方位品牌传播方案，从策略制定到执行落地，帮助品牌建立差异化竞争优势。",
    icon: "ri-rocket-line",
    articleCount: 29,
  },
  {
    slug: "shuju-fenxi",
    name: "数据分析",
    description: "基于大数据的内容效果追踪与用户画像分析，以数据驱动内容策略持续优化。",
    icon: "ri-bar-chart-2-line",
    articleCount: 22,
  },
  {
    slug: "zimeiti-yunying",
    name: "自媒体运营",
    description: "多平台自媒体矩阵搭建与运营管理，助力个人与机构打造可持续的内容变现体系。",
    icon: "ri-smartphone-line",
    articleCount: 41,
  },
  {
    slug: "hangye-zixun",
    name: "行业资讯",
    description: "数字传媒行业前沿动态、政策解读与趋势分析，助您把握行业脉搏抢占先机。",
    icon: "ri-newspaper-line",
    articleCount: 55,
  },
];

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}